import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { BasicResponse } from '@auth-suite-services/services';
import { Observable } from 'rxjs';
import { ProductList, ProductListAPI } from '../model/product-list';

/**
 * @description
 * @class
 */
@Injectable({ providedIn: 'root' })
export class ProductListService {
  private URL;
  headers: HttpHeaders;

  constructor(
    @Inject(ConfigService) private config: any,
    private httpClient: HttpClient
  ) {
    this.URL = config.REST_SERVER_HOST + '/api/amassapp';
    this.headers = new HttpHeaders().set('DoNotIntercept', 'true');
  }

  getAllProductList(
    pageIndex: number,
    pageSize: number,
    sortActive: string,
    sort: string
  ): Observable<ProductListAPI> {
    const headers = this.headers;
    const jsonObject = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortActive: sortActive ? sortActive : 'category',
      sort: sort ? sort : 'asc',
    };

    return this.httpClient.post<ProductListAPI>(
      `${this.URL}/pli/allpli`,
      jsonObject,
      { headers }
    );
  }

  createNewPLI(pli: ProductList): Observable<BasicResponse> {
    const headers = this.headers;
    const jsonObject = {
      category: pli.category,
      origin: pli.origin,
      feeAmount: pli.feeAmount,
      productAmount: pli.productAmount,
      productCode: pli.productCode,
      productDescription: pli.productDescription,
      status: pli.status,
    };
    console.log(jsonObject);
    return this.httpClient.post<BasicResponse>(
      `${this.URL}/pli/createpli`,
      jsonObject,
      { headers }
    );
  }

  getProductList(id: number) {
    const headers = this.headers;
    const jsonObject = {
      id: id,
    };
    return this.httpClient.post<ProductList>(
      `${this.URL}/pli/onepli`,
      jsonObject,
      { headers }
    );
  }

  updatePLI(pli: ProductList, id: number) {
    const headers = this.headers;
    const jsonObject = {
      id: id,
      category: pli.category,
      origin: pli.origin,
      feeAmount: pli.feeAmount,
      productAmount: pli.productAmount,
      productCode: pli.productCode,
      productDescription: pli.productDescription,
      status: pli.status,
    };
    console.log(jsonObject);
    return this.httpClient.post<BasicResponse>(
      `${this.URL}/pli/updatepli`,
      jsonObject,
      { headers }
    );
  }
}
